<template>
<div class="recommend">
  <span>Звонят клиентам напрямую?</span>
  <span :class="[!values ? 'greens' : '']">Нет</span>
  <v-switch
    v-model="values"
    style="display: inline-flex"
    color="red"
    :readonly="readonly"
  ></v-switch>
  <span :class="[values ? 'reds' : '']">Да</span>
</div>
</template>
<script>
export default {
  name: 'recommend',
  components:{},
  data:()=>({}),
  props:{
    value: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false}
  },
  computed:{
    values:{
      get(){
        return this.value
      },
      set(val){
        this.$emit('input',val)
      }
    }
  },
}
</script>
<style lang="sass" scoped>
.recommend
  display: flex
  column-gap: 10px
  align-items: center
  padding: 0 20px
  .reds
    color: red !important
  .greens
    color: green !important
</style>
